<div *ngIf="user && user.profileState != profileStates.APPROVED">
  <section class="panel panel-info">
    <div
      class="panel-heading iris-body-bold-responsive"
      data-test="heading-submitting-your-profile"
      data-dd-privacy="allow"
    >
      Submitting your profile
    </div>
    <div class="panel-body iris-body-responsive">
      <div *ngIf="user.profileState == profileStates.INREVIEW" data-test="profile-under-review-text">
        Your profile is currently under review.
      </div>
      <div *ngIf="user.profileState != profileStates.INREVIEW">
        <p data-test="profile-submit-for-public-view">Your profile needs to be submitted before it's visible to clients.</p>

        <div *ngIf="user.profileErrors"  aria-live="polite">
          <p data-test="items-to-fix-on-profile">Please complete the following before you submit your profile.</p>
          <ul data-test="profile-error-items">
            <li *ngFor="let error of user.profileErrors">
              {{error}}
            </li>
          </ul>
        </div>
        <div *ngIf="user.profileState == profileStates.REJECTED">
          <h4>Your profile was not approved for the following reason</h4>
          <p>{{user.profileRejectMessage}}</p>
        </div>
        <br>
        <iris-button-container>
          <iris-button
            [id]="user.profileErrors ? 'pendo-submit-profile-button-disabled' : 'pendo-submit-profile-button-enabled' "
            [disabled]="$any(saving || user.profileErrors)" 
            (click)="submitProfile()"
            attr.aria-label="{{ user.profileErrors ? 'Submit disabled due to errors' : 'Submit or resubmit your profile' }}"
            data-test="submit-or-resubmit-profile"
            data-dd-privacy="allow"
          >
            Submit or Resubmit Profile
          </iris-button>
        </iris-button-container>
      </div>
    </div>
  </section>
</div>
<ng-container *ngIf="user && user.profileState === profileStates.APPROVED && user.profileErrorTabs?.length > 0">
  <section class="panel panel-info">
    <div
      class="panel-heading iris-body-bold-responsive"
      data-test="heading-public-profile"
    >Complete your profile for better matches</div>
    <div class="panel-body iris-body-responsive">
      <p data-test="items-to-fix-on-approved-profile">
        To better meet client and provider needs, we've changed a few profile sections. To get the strongest matches possible, please complete the missing information on these tabs.
      </p>
      <ul>
        <li *ngFor="let tab of user.profileErrorTabs">
          <a
            class="iris-link-primary-responsive"
            [routerLink]="[tab.link]"
            [attr.data-test]="tab.dataTest"
          >
            {{ tab.name }}
          </a>
        </li>
      </ul>
    </div>
  </section>
</ng-container>